import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

// Безопасная работа с localStorage (iOS Safari может блокировать)
const safeGetToken = () => {
  try {
    return localStorage.getItem('token');
  } catch (e) {
    console.warn('localStorage недоступен:', e);
    return null;
  }
};

const safeRemoveToken = () => {
  try {
    localStorage.removeItem('token');
  } catch (e) {
    console.warn('localStorage недоступен:', e);
  }
};

// Добавление токена к каждому запросу
instance.interceptors.request.use(
  (config) => {
    const token = safeGetToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Обработка ошибок ответа
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      safeRemoveToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;

